"use strict";
exports.__esModule = true;
exports.stringToBytes = void 0;
function stringToBytes(s) {
    if (s === undefined) {
        return undefined;
    }
    if (!textEncoder) {
        textEncoder = new TextEncoder();
    }
    return textEncoder.encode(s);
}
exports.stringToBytes = stringToBytes;
var textEncoder;
//# sourceMappingURL=strings.js.map